/**
 * Image Generation Types
 */
enum ImageGenStatus {
  QUEUED = "queued",
  PROCESSING = "processing",
  COMPLETED = "completed",
  FAILED = "failed",
}
enum ImageAspectRatio {
  SQUARE = "1:1",
  PORTRAIT_2_3 = "2:3",
  LANDSCAPE_3_2 = "3:2",
  PORTRAIT_3_4 = "3:4",
  LANDSCAPE_4_3 = "4:3",
  PORTRAIT_4_5 = "4:5",
  LANDSCAPE_5_4 = "5:4",
  PORTRAIT_9_16 = "9:16",
  LANDSCAPE_16_9 = "16:9",
  ULTRAWIDE_21_9 = "21:9",
}
interface ImageGenRequest {
  id: string;
  workspaceId: string;
  projectId: string;
  prompt: string;
  expectedFilename: string;
  aspectRatio: ImageAspectRatio;
  referenceUrls?: string[];
  status: ImageGenStatus;
  jobId?: string;
  resultFileId?: string;
  errorMessage?: string;
  metadata?: Record<string, any>;
  createdBy: string;
  createdAt: Date;
  updatedAt: Date;
  completedAt?: Date;
}
interface CreateImageGenRequestDto {
  projectId: string;
  prompt: string;
  expectedFilename: string;
  aspectRatio?: ImageAspectRatio;
  referenceUrls?: string[];
}
interface ImageGenJobPayload {
  requestId: string;
  workspaceId: string;
  workspaceRefId: string;
  projectId: string;
  prompt: string;
  aspectRatio: ImageAspectRatio;
  referenceUrls?: string[];
  expectedFilename: string;
  // Local save options (skip R2, save directly to dev-container)
  saveLocal?: boolean;
  devContainerId?: string;
}
interface BgRemovalJobPayload {
  requestId: string;
  workspaceId: string;
  workspaceRefId: string;
  projectId: string;
  sourceUrl: string; // URL of the source image to process
  expectedFilename: string;
  // Local save options (skip R2, save directly to dev-container)
  saveLocal?: boolean;
  devContainerId?: string;
}
interface ImageGenJobResult {
  success: boolean;
  requestId: string; // Original request ID from NestJS
  fileRefId?: string; // Generated file reference ID (nanoid(21))
  filePath?: string; // Full path in R2: assets/{workspaceRefId}/img-gen/{fileRefId}-{slug}.{ext}
  parUrl?: string; // Pre-authenticated URL (15 min expiry)
  fileSize?: number; // File size in bytes
  dimensions?: {
    width: number;
    height: number;
  };
  generationTime?: number; // Time taken in milliseconds
  error?: string;
  errorCode?: string;
  metadata?: Record<string, any>;
  // Local save result fields
  savedLocally?: boolean; // True if saved to dev-container instead of R2
  localFilePath?: string; // Local path within dev-container (e.g., /workspaces/public/assets/hero.png)
  imageData?: string; // Base64 encoded image data (when saveLocal=true, worker returns this instead of uploading to R2)
}

export { ImageGenStatus, ImageAspectRatio };

export type {
  ImageGenRequest,
  CreateImageGenRequestDto,
  ImageGenJobPayload,
  BgRemovalJobPayload,
  ImageGenJobResult,
};
